export const userEnglish = {
  lang: 'en',
  data: {
    USER: {
      BLOCK: 'Blokkeer administratie',
      DELETE: 'Verwijder administratie',
      LEDGER: 'Bekijk administratie',
      LOGIN: 'Inloggen als deze administratie',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/i18n/en.ts